module.exports = __webpack_public_path__ + "img/agentLogo.4839c0e8.png";